import { create } from 'zustand';

interface ModalState {
  loginModalMode: 'none' | 'home' | 'signin' | 'signup';
  finishingSignup: boolean;
  setLoginModalMode: (mode: 'none' | 'home' | 'signin' | 'signup') => void;
  setFinishingSignup: (finishingSignup: boolean) => void;
}

export const useModalStore = create<ModalState>((set) => ({
  loginModalMode: 'none',
  finishingSignup: false,
  setLoginModalMode: (mode: 'none' | 'home' | 'signin' | 'signup') =>
    set({ loginModalMode: mode }),
  setFinishingSignup: (finishingSignup: boolean) => set({ finishingSignup }),
}));
